export const getRandomNumber = (max) => {
  return Math.floor(Math.random() * max);
};

export const getRandomNumberFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};
